import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 98803 78877"
    {...props}
  >
    <path
      d="M98803 42336v7376H82872l-8181 15960c-807 1145-1985 1924-3533 1924-1550-375-2725-1147-3103-2729l-6197-17850-5825 13201c-436 1179-1986 2327-3534 1952-1922 0-3100-1175-3533-3100l-5019-31858-6198 48532c-436 1954-1612 3133-3533 3133-1923 0-3472-1179-3905-2727l-7005-37685-4648 9328c-372 1176-1920 1922-3101 1922L0 49714v-7375h13202l8180-17076c807-1550 2357-2328 3907-2328 1548 372 2727 1548 3099 3101l5083 26437 6198-49372C40038 1178 41653 0 43202 0c1919 0 3472 1178 3841 3101l7005 42738 4712-10845c369-1583 1920-2357 3473-2357 1547 0 2726 1178 3470 2726l6631 19031 5083-10107c746-1175 1922-1951 3472-1951h17914z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
